// extracted by mini-css-extract-plugin
export var active = "_dh-7";
export var container = "_dh-0";
export var evenWidth = "_dh-4";
export var large = "_dh-5";
export var outlet = "_dh-8";
export var slide = "_dh-2";
export var small = "_dh-6";
export var tab = "_dh-3";
export var tabs = "_dh-1";